(function() {
  const blockedSrc = "https://ecommerce-editor-connector.live.gelato.tech/ecommerce-editor/v1/shopify.esm.js";

  const originalAppendChild = Element.prototype.appendChild;
  const originalInsertBefore = Element.prototype.insertBefore;

  Element.prototype.appendChild = function(child) {
    if (child.tagName === 'SCRIPT' && child.src && child.src.includes(blockedSrc)) {
      console.warn("Blocked unwanted script from Gelato:", child.src);
      return child;
    }
    return originalAppendChild.call(this, child);
  };

  Element.prototype.insertBefore = function(newNode, referenceNode) {
    if (newNode.tagName === 'SCRIPT' && newNode.src && newNode.src.includes(blockedSrc)) {
      console.warn("Blocked unwanted script from Gelato:", newNode.src);
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (node.tagName === 'SCRIPT' && node.src && node.src.includes(blockedSrc)) {
          console.warn("Removed unwanted script from Gelato after insertion:", node.src);
          node.parentElement.removeChild(node);
        }
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

})();
